

<!-- @if (isLoading) {
  <lib-loading-indicator [isLoading]="isLoading"></lib-loading-indicator>
} -->
<div class="projectable-form-wrapper frontdoor-form"
  (keyup.escape)="closeModal(false)"
  >
  <lib-form-header
    [data]="formData"
    [title]="'Enroll New Agent'"
    (actionRequested)="headerActionRequested($event)"
    [(formView)]="formView"
  ></lib-form-header>
  <div class="integration-form-container projectable-form-container">

    @if (formView === 'simple') {
    <div class="projectable-form-main-column form-group-row">
    <section id="header">
            <div>
                <app-message
                      severity="info"
                    text="The agent runs on your hardware and provides access to your applications. Each agent should be located as close to the application server as you can get it. On the same machine is best. An agent can access one or many applications. Each application must have at least one agent linked to it."
                ></app-message>
            </div>
    </section>
        
    <section id="header">
                <div class="title special headerStyle">Agent Registration</div>
                <div class="explain headerStyle">
                    <p class="mt0 mb8">
                        Agent software must be installed and registered before it can be used to access your service. There are packages available for most operating systems. Please refer to <a href="https://netfoundry.io/docs/frontdoor/learn/agents/" target="_blank">this document</a> for instructions to download and install the agent software.
                    </p>
                    <div class="form-row">
                        <label class="form-label">Agent Enrollment Token</label>
                        <span class="tokenClass">{{this.token}}</span>
                        <span style="cursor: pointer; margin-left: 7px" (click)="copyToken(this.token)" class="pi pi-copy"></span>
                    </div>
                    <div class="form-row description-row">
                        <label class="form-label">Name your agent
                            <div class="infoicon" matTooltip="This is how it will appear in your agent list. Without a name, it will show as something like agent@example.com" matTooltipPosition="below"></div>
                        </label>
                        <input placeholder="Add a description for your agent" [(ngModel)]="this.description" />
                    </div>
                </div>
            <div class="title special">Registration Instructions</div>
                <div class="explain instructions-row">
                    <pre class="rowCNameRecord">
<code>{{this.firstCommand}}
{{this.secondCommand}}{{this.token}}{{this.description ? ' --description "' + this.description + '"' : ''}}
{{this.thirdCommand}}</code>
                    </pre>
                    <span style="cursor: pointer; margin-left: 7px; align-self: center" (click)="copyText(this.combinedScript)" class="pi pi-copy"></span>
                </div>
        </section>
    </div>

    }
    @if (formView === 'raw') {
      <div class="form-group-column">
        @if (formData) {
          <lib-json-view [(data)]="formData"></lib-json-view>
        }
      </div>
    }

  </div>
</div>
